import { render, staticRenderFns } from "./UnderMaintenance.vue?vue&type=template&id=43235e2c"
import script from "./UnderMaintenance.vue?vue&type=script&lang=js"
export * from "./UnderMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports